module.exports = vendors_ru_7bfd30ef4dafebb86eb9;